module.exports = __webpack_public_path__ + "static/img/brees-2010-slide-3.87e4217.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2010-slide-3.jpg
// module id = mccq
// module chunks = 1